import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BaseComponent } from "../../../base.component";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { HttpWrapperService } from "../../../_services/http.wrapper.service";
import { DataService } from "../../../_services/data.service";
import { AlertService } from "../../../_services/alert.service";
import { DownloadReceiptService } from "../../../_services/download-receipt.service";

@Component({
  moduleId: module.id,
  selector: "payment-result",
  templateUrl: "./payment-result.component.html",
  styleUrls: ["./payment-result.component.scss"],
  providers: [HttpWrapperService],
})
export class PaymentResultComponent extends BaseComponent {
  @Input() public paymentResult: any;
  @Output() public itemSelected: EventEmitter<any> = new EventEmitter<any>();
  @Input() public isCollapsed: boolean;
  @Output() public isCollapsedChange = new EventEmitter<boolean>();
  @Input() public itemDetails: any;
  @Input() public disableItemSelect: boolean;
  @Output() public itemDetailsChange = new EventEmitter<any>();
  @Output() public onShouldReload: EventEmitter<any> = new EventEmitter<any>();

  public modalReference: any;
  public paymentType: string;
  public collectiveRefundFeatureFlag: boolean;

  constructor(
    public dataService: DataService,
    public sessionManager: SessionManagerService,
    private alertService: AlertService,
    private receiptService: DownloadReceiptService,
    private modalService: NgbModal
  ) {
    super(dataService, sessionManager);
    this.collectiveRefundFeatureFlag =
      this.sessionManager.features.collectiveRefund;
  }

  public run() {
    this.paymentResult.address = this.combineString([
      this.paymentResult.city,
      this.paymentResult.street,
      this.paymentResult.house,
    ]);
    this.paymentResult.parentFullName = this.combineString([
      this.paymentResult.parentFirstName,
      this.paymentResult.parentLastName,
    ]);
    this.paymentResult.userFullName = this.combineString([
      this.paymentResult.userFirstName,
      this.paymentResult.userLastName,
    ]);
    this.paymentResult.childFullName = this.combineString([
      this.paymentResult.childFirstName,
      this.paymentResult.childLastName,
    ]);
    this.paymentResult.payerFullName = this.combineString([
      this.paymentResult.payerFirstName,
      this.paymentResult.payerLastName,
    ]);
    if (this.paymentResult.paymentType <= 3)
      this.paymentType = this.base.messages.payment_type_CREDIT_CARD;
    else if (
      this.paymentResult.paymentType == 4 ||
      this.paymentResult.paymentType == 8 ||
      this.paymentResult.paymentType == 9
    )
      this.paymentType = this.base.messages.payment_type_CASH;
    else if (this.paymentResult.paymentType == 5)
      this.paymentType = this.base.messages.payment_type_CHECK;
    else if (
      this.paymentResult.paymentType == 7 ||
      this.paymentResult.paymentType == 6
    )
      this.paymentType = this.base.messages.payment_type_CASH_AND_CHECK;
    else if (this.paymentResult.paymentType >= 10)
      this.paymentType = this.base.messages.payment_type_COMMITMENT;
  }

  public combineString(strings: string[]) {
    let returnedString = "";
    strings.forEach((str) => {
      returnedString += str ? " " + str : "";
    });
    return returnedString;
  }

  public check() {
    this.itemDetails.isChecked = this.itemDetails.isChecked ? false : true;
    this.itemSelected.emit(this.itemDetails.isChecked);
    // 		event.stopPropagation();

    // 	 	this.selectedItems.push(paymentResult);
  }

  public openUrlFromHeader(e) {
    e.preventDefault();
    e.stopPropagation();
    window.open(this.paymentResult.receiptUrl);
  }

  public onActionCompletedSingleItem() {
    this.onShouldReload.emit();
  }

  public isCashNotDeposited() {
    return (
      this.paymentResult.paymentType >= 4 &&
      this.paymentResult.paymentType <= 7 &&
      this.paymentResult.openCheck === "1"
    );
  }

  public getItemDetails() {
    if (!this.itemDetails.eventQuestions && !this.itemDetails.returnTable) {
      this.dataService
        .postEntity("itemDetails", { paymentId: this.paymentResult.id })
        .subscribe(
          (data) => {
            const event = { questions: [], submittedQuestions: {} };
            if (data.questions && data.questions.length > 0) {
              data.questions.forEach((q) => {
                const question = {};
                question["questionId"] = q.questionId;
                question["questionText"] = q.questionText;
                question["answers"] = [];
                if (q.answers) {
                  q.answers.forEach((a) => {
                    question["answers"].push({
                      answerId: a.id,
                      answerText: a.answerBody,
                    });
                  });
                }
                event.questions.push(question);
                if (this.getType(question) == 0) {
                  event.submittedQuestions[question["questionText"]] =
                    q.saAnswer;
                } else if (this.getType(question) == 1) {
                  event.submittedQuestions[question["questionText"]] =
                    q.saAnswer && q.saAnswer !== "" ? true : false;
                } else if (this.getType(question) == 2) {
                  const selectedAnswer = question["answers"].find(
                    (a) => (a.answerText = q.saAnswer)
                  );
                  event.submittedQuestions[question["questionText"]] =
                    selectedAnswer;
                }
              });
            }

            this.itemDetails.eventQuestions = event;

            if (data.returnTable && data.returnTable.length > 0) {
              this.itemDetails.returnTable = data.returnTable;
              const eventDate = new Date(this.paymentResult.eventDate);
              const returnDate = new Date(data.returnTable[0].timeAndDate);
              this.paymentResult.refundHoursDiffrence =
                Math.round(
                  ((eventDate.getTime() - returnDate.getTime()) / 36e5) * 10
                ) / 10;
            } else {
              this.itemDetails.returnTable = [];
            }
            this.itemDetailsChange.emit(this.itemDetails);

            this.paymentResult.returnAmount = data.returnAmount;
            this.paymentResult.refundTypes = data.refundTypes;
          },
          (error) => {
            const body = error.json && error.json();
            const msg =
              body && body.statusText
                ? this.base.messages[body.statusText]
                  ? this.base.messages[body.statusText]
                  : decodeURIComponent(body.statusText)
                : (error && error.statusText) || "error";
            if (msg === "error") {
              location.reload();
            } else {
              this.alertService.error(msg);
            }
          }
        );
    }
  }

  public getQuestionsBtn(ev, content) {
    ev.stopPropagation();
    this.open(content);
  }

  public toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.isCollapsedChange.emit(this.isCollapsed);
    this.getItemDetails();
  }

  public formatDate(dateStr: string) {
    const dateArray = dateStr.split(" ")[0].split("-");
    const hourArray = dateStr.split(" ")[1].split(":");
    const date = new Date(
      // tslint:disable-next-line:radix
      parseInt(dateArray[0]),
      // tslint:disable-next-line:radix
      parseInt(dateArray[1]) - 1,
      // tslint:disable-next-line:radix
      parseInt(dateArray[2]),
      // tslint:disable-next-line:radix
      parseInt(hourArray[0]),
      // tslint:disable-next-line:radix
      parseInt(hourArray[1]),
      0,
      0
    );
    const returnStrTime = `${date.getHours()}:${
      date.getMinutes().toString().length == 1
        ? "0" + date.getMinutes().toString()
        : date.getMinutes()
    }`;
    const returnedStrDate = `${date.getDate()}.${
      date.getMonth() + 1
    }.${date.getFullYear()}`;
    const twoDigitYear = date.getFullYear().toString().slice(-2);
    const returnedMobileStrDate = `${date.getDate()}.${
      date.getMonth() + 1
    }.${twoDigitYear}`;
    return {
      date: returnedStrDate,
      time: returnStrTime,
      mobileDate: returnedMobileStrDate,
    };
  }

  public open(content: any) {
    const options: NgbModalOptions = {
      windowClass: "modal-opened",
      backdrop: "static",
    };
    this.modalReference = this.modalService.open(content, options);
  }

  //0 - desc, 1 - check, 2 - multi
  public getType(question) {
    if (question.answers && question.answers.length > 0) {
      return question.answers.length == 1 ? 1 : 2;
    } else return 0;
  }

  public async downloadReceipt($event: MouseEvent, receiptNum: any) {
    $event.stopPropagation();
    $event.preventDefault();
    await this.receiptService.downloadReceiptByNumber(receiptNum);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/payments/payemnt-result/payment-result.component.ts